<template>
  <div class="registered">
    <h2 class="user_registered">User registration</h2>
    <el-form ref="form"  :model="form" :rules="rules" label-width="200px">
      <el-form-item label="E-mail" prop="email">
        <el-input v-model="form.email" placeholder="Email"></el-input>
      </el-form-item>
      <el-form-item label="" prop="code">
        <el-input class="input_Code" v-model="form.code" placeholder="Input the verification code"></el-input>
        <el-button class="btn_Code" type="primary" @click="sendCode" :disabled="codeFalg">{{countdown}}</el-button>
      </el-form-item>
      <el-form-item label="Full Name" prop="name">
        <el-input v-model="form.name" placeholder="Input your name"></el-input>
      </el-form-item>
      <el-form-item label="Company Name" prop="corpname">
        <el-input v-model="form.corpname" placeholder="Input company name"></el-input>
      </el-form-item>
      <el-form-item label="country" prop="country">
        <el-select v-model="form.country" placeholder="Select country">
          <el-option v-for="(item,i) in country" :key="i" :label="item[2]" :value="item[2]"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Mobile" prop="pass">
        <el-input v-model="form.mobile" placeholder="Input mobile number"></el-input>
      </el-form-item>
      <el-form-item label="password" prop="pwd" >
        <el-input type="password" v-model="form.pwd" autocomplete="off" placeholder="Input password" show-password></el-input>
      </el-form-item>
      <el-form-item class="btnGroup">
        <el-button type="primary" @click="submitForm('form')">Register now</el-button>
        <el-button @click="resetForm('form')">reset</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
// https://wuliu.taobao.com/user/output_address.do?range=country
<script>
import { reqLoginEmail, reqRegEn } from "../../../api";
import { tdist_country } from "../../../mock/country";
export default {
  data() {
    var validateEmail = (rule, value, callback)=>{
      if (value === '') {
        this.codeFalg = true
        callback(new Error('The mailbox address cannot be empty'));
      } else if(!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)){
        this.codeFalg = true
        callback(new Error('Input email address'));
      } else {
        this.codeFalg = false
        console.log(this.codeFalg);
        callback();
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Input password'));
      } else if(value.length<6||value.length>16){
        callback(new Error('Input a 6-15 digit password'));
      } else {
        if (this.form.pwd !== '') {
          this.$refs.form.validateField('checkpwd');
        }
        callback();
      }
    };
    // var validatePass2 = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('Please enter your password again'));
    //   } else if (value !== this.form.pwd) {
    //     callback(new Error('两次输入密码不一致!'));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      rules:{
        email:[
           { validator: validateEmail, trigger: 'change' }
          ],
        name:[
          { required: true, message: 'Input your name', trigger: 'blur' },],
        corpname:[
          { required: true, message: 'Input company name', trigger: 'blur' }],
        country:[
          { required: true, message: 'Select country', trigger: 'change' }],
        pwd:[
          { validator: validatePass, trigger: 'blur' }],
        // checkpwd:[
        //   { validator: validatePass2, trigger: 'blur' }],
      },
      form: {
        email:'',
        name: "",
        corpname: "",
        country: "",
        duties: "",
        mobile: '',
        tel: "",
        pwd: "",
        checkpwd:''
      },
      codeFalg:true,
      countdown:'verification code',//倒计时
      country:{},
    };
  },

  async mounted(){
    this.country = tdist_country
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async submit(){
      const response =await reqRegEn(this.form)
      console.log(response);
      if (response.code*1==3) {
        this.err(this,'验证码错误')
      }else if (response.code*1==2) {//成功
        this.$router.push('/')
        this.success(this,'Registered Successful')
        // this.$store.dispatch("dialog",true)
      }else{
        this.err(this,'Registered failure')
      }
    },
    async sendCode(){
      const response = await reqLoginEmail({email:this.form.email})
      if (response.code*1==3) {
        this.success(this,'Sent successfully')
        this.countdown = 90
        this.disabled = true
        this.time()
      }else if(response.code*1==1){
        this.err(this, 'Email Registered')
      }else{
        this.err(this,'Sent failure')
      }
    },
    time(){//倒计时
      this.timer = setInterval(()=>{
        this.countdown--
        if (this.countdown<=0) {
          clearInterval(this.timer)
          this.countdown = "verification code"
          this.disabled = false
        }
      },1000)
    },
  },
};
</script>

<style scoped>
  .registered{
    max-width: 668px;
    margin: auto;
    letter-spacing: .1em;
    min-height: calc(100vh - 261px);
  }
  .user_registered{
    text-align: center;
    padding: 40px;
    font-size: 28px;
    letter-spacing: .1em;
  }
  .registered >>> .el-form-item__label{
    padding-right: 40px;
  }
  .registered >>> .el-input{
    width: 400px;
  }
  .registered .input_Code{
    width: calc(400px - 130px);
    margin-right: 18px;
  }
  .btn_Code{
    width: 112px;
    padding-left: 0;
    padding-right: 0;
  }
  @media (min-width: 768px) and (max-width: 869px) {
    .registered{
      min-height: calc(100vh - 311px);
    }
  }

</style>